<template>
  <section>
    <v-dialog
      v-model="isShow"
      width="400px">
      <div class="dialog-container">
        <div class="dialog-header">
          <span>Pro/Pro Plus</span>
        </div>
        <div class="dialog-body">
          <v-radio-group
            v-model="level"
            block
            :list="vip_level_list"></v-radio-group>
          <div
            v-if="level==1"
            class="form-item mg-t-10">
            <v-checkbox
              v-model="is_special_pro"
              :is-boolean="false">Custom Referrer Discount</v-checkbox>
          </div>
        </div>
        <div class="dialog-footer">
          <v-button
            gray
            @click="handleCancel">Cancel</v-button>
          <v-button
            green
            @click="handleContinue">Confirm</v-button>
        </div>
      </div>
    </v-dialog>
  </section>
</template>

<script>
import MixinOptions from '@/mixins/options'
import {changeAccountLevel} from '@api/account'

export default {
  name: 'changePro',
  mixins: [MixinOptions],
  props:{
    value:{
      type: Boolean,
      default: false
    },
    levelId:{
      type: Number,
      default: 0
    },
    isSpecialPro:{
      type: Number,
      default: 0
    }
  },
  data(){
    return{
      isShow: false,
      level:'',
      is_special_pro:''
    }
  },
  computed:{
    user_id(){
      let {customer_id} = this.$route.query||{}
      return customer_id
    }
  },
  watch:{
    value:{
      immediate:true,
      handler(val){
        this.isShow = val
      }
    },
    levelId:{
      immediate:true,
      handler(val){
        this.level = val
      }
    },
    isSpecialPro:{
      immediate:true,
      handler(val){
        this.is_special_pro = val
      }
    },
  },
  methods:{
    handleCancel(){
      this.$emit('input',false)
    },

    handleContinue(){
      this.network().changeAccountLevel()
    },
    network() {
      return {
        changeAccountLevel: async () => {
          let params = {
            user_id: this.user_id,
            level:this.level,
            is_special_pro:this.level==1?this.is_special_pro:0
          }
          const {data} = await changeAccountLevel(params)
          this.$emit('update')
          this.$emit('input',false)
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
::v-deep .el-dialog{
  box-sizing: border-box;
  border-radius: 6px;
}
.dialog-container {
  .dialog-header {
    padding: 16px;
    background: #F6F8FA;
    border-bottom: 1px solid #E1E4E8;
    border-radius: 6px 6px 0 0;
    span{
      font-style: normal;
      font-weight: 600;
      font-size: 14px;
      line-height: 20px;
      display: flex;
      align-items: center;
      color: #1B1F23;
      flex: none;
      order: 0;
      align-self: stretch;
      flex-grow: 0;
      /*margin: 10px 0px;*/
    }
  }
  .dialog-body{
    padding: 20px 15px;
    .tips{
      color: #24292E;
    }
  }
  .dialog-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px;
    padding-top: 0;
    .btn{
      color: #24292E;
    }
  }
}
</style>
